<template>
<div class="app" :class="{ 'vk-mini-app': vkMiniApp }">
  <component :is="layout">
    <router-view class="page"></router-view>
  </component>
  <popup-notification v-for="notification in notifications"
                      :key="`notification-${notification.id}`"
                      :title="notification.title"
                      :description="notification.description"
                      :icon="notification.icon"
                      :disabled="notification.disabled"
                      @closed="notificationClosed(notification)"
  />
</div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout'
import EmptyLayout from '@/layouts/EmptyLayout'
import PopupNotification from '@/components/notifications/PopupNotification'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    PopupNotification
  },

  computed: {
    ...mapGetters({
      notifications: 'notifications/notifications',
      vkMiniApp: 'ui/vkMiniApp',
    }),

    layout() {
      if (!this.$route.meta || !this.$route.meta.layout) {
        return MainLayout
      }

      switch (this.$route.meta.layout) {
        case 'main':
          return MainLayout
        case 'empty':
          return EmptyLayout
      }

      return MainLayout
    },

    firstNotification() {
      return this.notifications[0] || null
    },
  },

  methods: {
    ...mapMutations({
      removeNotification: 'notifications/removeNotification',
    }),

    notificationClosed(notification) {
      this.$nextTick(() => this.removeNotification(notification.id))
    },
  },
}
</script>
